module.exports = __webpack_public_path__ + "static/media/review2.5bf74096.webp";